import { render, staticRenderFns } from "./CollectionDetails.vue?vue&type=template&id=245ee534"
import script from "./CollectionDetails.vue?vue&type=script&lang=ts"
export * from "./CollectionDetails.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports